import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import PollIcon from "@material-ui/icons/Poll";
import CommentIcon from "@material-ui/icons/Comment";

import { Logo } from "../../Logo/Logo";

import { Link, useHistory } from "react-router-dom";

import "./sidemenu.style.scss";

const options = [
  {
    title: "Artigos",
    Icon: DescriptionIcon,
    url: "/artigos",
  },
  {
    title: "Enquetes",
    Icon: PollIcon,
    url: "/enquetes",
  },
  {
    title: "Comentários",
    Icon: CommentIcon,
    url: "/comentarios",
  },
];

const MenuOption = ({ liRef, title, url, Icon, className }) => (
  <Link to={url}>
    <ListItem className={className} ref={liRef} button key={title}>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={title} />
    </ListItem>
  </Link>
);

const SideMenu = () => {

  const history = useHistory();

  const currentPage = history.location.pathname;

  return (
    <div className="sidemenu">
      <div className="sidemenu__logo">
        <Logo />
      </div>
      <div className="sidemenu__menu">
        <span>Menu</span>
        {options.map((opt) => (
            <MenuOption
              className={ currentPage === opt.url ? 'active' : ''}
              key={opt.title}
              title={opt.title}
              Icon={opt.Icon}
              url={opt.url}
            />
          ))}
      </div>
    </div>
  );
};

export default SideMenu;